import { render, staticRenderFns } from "./informationPriceDialog.vue?vue&type=template&id=5969bbc8&scoped=true"
import script from "./informationPriceDialog.vue?vue&type=script&lang=js"
export * from "./informationPriceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5969bbc8",
  null
  
)

export default component.exports